export class RoomsGroup {
    id: string;
    name: string;
    listOfRooms: Array<string>;
}
